var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-wrapper"},[_c('div',{staticStyle:{"padding":"0 0 3px 10px"}},[_vm._v("2. 图形选项设置:")]),_c('div',{staticClass:"option-setting"},[_c('keep-alive',[_c(_vm.activeType,{ref:"chartSetting",tag:"component"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }